<ng-progress ngProgressHttp ngProgressRouter [spinner]="false"></ng-progress>

<router-outlet></router-outlet>

<ng2-toasty></ng2-toasty>
<p-confirmDialog header="Confirmação" icon="fa fa-question-circle" appendTo="body" #confirmacao>
    <p-footer>
        <button type="button" pButton icon="fa-check" label="Sim" (click)="confirmacao.accept()"></button>
        <button type="button" pButton icon="fa-times" label="Não" (click)="confirmacao.reject()"></button>
    </p-footer>
</p-confirmDialog>